/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var assertFragmentMap = require('./assertFragmentMap');

var _require = require('./ReactRelayContainerUtils'),
    getComponentName = _require.getComponentName,
    getContainerName = _require.getContainerName;

var ReactRelayContext = require('./ReactRelayContext');

var ReactRelayQueryRendererContext = require('./ReactRelayQueryRendererContext');

var readContext = require('./readContext');

var invariant = require('invariant');

var React = require('react');

var _require2 = require('relay-runtime'),
    getFragment = _require2.getFragment;

/**
 * Helper to create the Relay HOCs with ref forwarding, setting the displayName
 * and reading the React context.
 */
function buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
  // Sanity-check user-defined fragment input
  var containerName = getContainerName(ComponentClass);
  assertFragmentMap(getComponentName(ComponentClass), fragmentSpec);
  var fragments = {};

  for (var key in fragmentSpec) {
    fragments[key] = getFragment(fragmentSpec[key]);
  }

  var Container = createContainerWithFragments(ComponentClass, fragments);
  Container.displayName = containerName;

  function forwardRef(props, ref) {
    var _queryRendererContext;

    var context = readContext(ReactRelayContext);
    !(context != null) ? process.env.NODE_ENV !== "production" ? invariant(false, '`%s` tried to render a context that was not valid this means that ' + '`%s` was rendered outside of a query renderer.', containerName, containerName) : invariant(false) : void 0;
    var queryRendererContext = readContext(ReactRelayQueryRendererContext);
    return /*#__PURE__*/React.createElement(Container, (0, _extends2["default"])({}, props, {
      __relayContext: context,
      __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
      componentRef: props.componentRef || ref
    }));
  }

  forwardRef.displayName = containerName;
  var ForwardContainer = React.forwardRef(forwardRef);

  if (process.env.NODE_ENV !== "production") {
    // Used by RelayModernTestUtils
    ForwardContainer.__ComponentClass = ComponentClass;
    ForwardContainer.displayName = containerName;
  } // $FlowFixMe[incompatible-return]


  return ForwardContainer;
}

module.exports = buildReactRelayContainer;